import { render, staticRenderFns } from "./ThreadsEmptyState.vue?vue&type=template&id=655734d4"
import script from "./ThreadsEmptyState.vue?vue&type=script&lang=js"
export * from "./ThreadsEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports